<template>
  <ReactPage>
    <locality-mapping-config-page></locality-mapping-config-page>
  </ReactPage>
</template>

<script>
import ReactPage from "../components/ReactPage.vue";

export default {
  name: "LocalityMappingConfig",
  components: {
    ReactPage,
  },
};
</script>
